import FloatingBlock from './FloatingBlock';

export default FloatingBlock;
